module.exports = __webpack_public_path__ + "static/img/ground1.49618d2d.png";